import InfoTooltip from 'components/InfoTooltip';
import TextAreaInput from 'components/forms/inputs/rhf-inputs/TextAreaInput';
import { TaskFormState } from './useTaskForm';

/** Notes. */
export const NotesFields = ({ form }: { form: TaskFormState }): JSX.Element => (
    <TextAreaInput
        control={form.methods.control}
        name="notes"
        label="tasks.notes"
        placeholder="forms.enter-notes"
        minRows={4}
        enableAutofill
        tooltip={<InfoTooltip text={'tasks.tooltips.notes'} />}
    />
);
